import { render, staticRenderFns } from "./tableIntwe.vue?vue&type=template&id=56c28a36&scoped=true&slot-scope=scope&"
import script from "./tableIntwe.vue?vue&type=script&lang=js&"
export * from "./tableIntwe.vue?vue&type=script&lang=js&"
import style0 from "./tableIntwe.vue?vue&type=style&index=0&id=56c28a36&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c28a36",
  null
  
)

export default component.exports